import { Navigate, useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { matrixQueries } from "@/domains/matrix";
import { MatrixSidebar } from "../../components/matrix-sidebar";
import { MatrixEmptyState } from "./components/matrix-empty-state";
import { MatrixDetailView } from "./components/matrix-detail-view";
import { MatrixLoadingCard } from "./components/matrix-loading-card";

export function MatrixPage() {
  const { collectionId } = useParams<{ collectionId?: string }>();
  const { data: matrices, isLoading } = useQuery(matrixQueries.list());

  if (collectionId) {
    return (
      <MatrixDetailView collectionId={collectionId} matrices={matrices ?? []} />
    );
  }

  if (isLoading) {
    return <MatrixLoadingCard />;
  }

  const firstMatrix = matrices?.[0];
  if (firstMatrix) {
    return <Navigate replace to={`/matrix/${firstMatrix.collectionId}`} />;
  }

  return (
    <>
      <title>Matrix - Researchly</title>
      {/* -mb-4 eats the shell's bottom padding so the rail and its list run
          all the way down to the footer; the content column puts the same
          distance back, since only the rail wants the extra height. */}
      <div className="-mb-4 flex w-full max-w-full flex-1 flex-col gap-0 overflow-hidden contain-size lg:flex-row lg:gap-0">
        <MatrixSidebar matrices={matrices ?? []} activeCollectionId={null} />
        <div className="mb-4 flex min-h-0 min-w-0 flex-1 flex-col gap-4 py-4 sm:py-6 lg:pr-6 lg:pl-6">
          <MatrixEmptyState />
        </div>
      </div>
    </>
  );
}
